import { AbstractControl } from '@angular/forms';
import { Exclude, Expose } from 'class-transformer';

import { BaseRecord } from '../shared-models';
import {IThreadState} from "./thread.model";

export enum ELeadField {
  Id = 'id',
  Name = 'name',
  Phone = 'phone',
  Email = 'email',
  LeadSource = 'lead_source',
  UnitIds = 'unit_ids',
  Units = 'units',
  Score = 'score',
  Status = 'status',
  PostalCode = 'postal_code',
  InternalNote = 'internal_note',
  MessageThreadId = 'message_thread_id',
  MessageThreadHasMessages = 'message_thread_has_messages',
  MessageThreadState = 'message_thread_state',
  MessageThreadUnreadCount = 'message_thread_unread_count',
  NotesMessageThreadId = 'notes_message_thread_id',
  NotesMessageThreadState = 'notes_message_thread_state',
  NotesMessageThreadUnreadCount = 'notes_message_thread_unread_count',
}

export class LeadBaseModel {
  @Expose({ name: ELeadField.Id })
  id!: number;
  @Expose({ name: ELeadField.Name })
  name!: string;
  @Expose({ name: ELeadField.Phone })
  phone!: string;
  @Expose({ name: ELeadField.Email })
  email!: string;
  @Expose({ name: ELeadField.LeadSource })
  leadSource!: BaseRecord | null;
  @Expose({ name: ELeadField.Units })
  units!: { id: number; identifier: string }[];
  @Expose({ name: ELeadField.Score })
  score!: ELeadScore;
  @Expose({ name: ELeadField.Status })
  status!: ELeadStatus;
  @Expose({ name: ELeadField.PostalCode })
  postalCode!: string;
  @Expose({ name: ELeadField.InternalNote })
  internalNote!: { id: number; note: string } | null;
  @Expose({ name: ELeadField.MessageThreadId })
  messageThreadId!: number | null;
  @Expose({ name: ELeadField.MessageThreadUnreadCount })
  messageThreadUnreadCount!: number;
  @Expose({ name: ELeadField.MessageThreadHasMessages })
  messageThreadHasMessages!: boolean;
  @Expose({ name: ELeadField.NotesMessageThreadId })
  notesMessageThreadId!: number | null;
  @Expose({ name: ELeadField.NotesMessageThreadUnreadCount })
  notesMessageThreadUnreadCount!: number;

  @Exclude()
  selected?: boolean;

  get unitsIdentifiers(): string[] {
    return this.units ? this.units.map((u) => u.identifier) : [];
  }

  get unreadCounter(): number {
    return this.messageThreadUnreadCount + this.notesMessageThreadUnreadCount;
  }
}

export class LeadModel extends LeadBaseModel {
  @Expose({ name: ELeadField.MessageThreadState })
  messageThreadState!: IThreadState;
  @Expose({ name: ELeadField.NotesMessageThreadState })
  notesMessageThreadState!: IThreadState;
}

export enum ELeadScore {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum ELeadStatus {
  NoOffer = 'no_offer',
  DialogStarted = 'dialog_started',
  Registered = 'registered',
  ContactAttempted = 'contact_attempted',
  AwaitingDecision = 'awaiting_decision',
  ShowingBooked = 'showing_booked',
  OfferSubmitted = 'offer_submitted',
}

export type LeadFormGroupType = {
  [key in ELeadField]?: AbstractControl<any>;
};
export type LeadFormGroupRawValue = {
  [key in ELeadField]?: any;
};

export enum ELeadDetailsModalTab {
  Details = 'details',
  CustomerCommunication = 'customer_communication',
  Discussion = 'discussion',
  Notes = 'notes',
}

export enum ELeadReserveUnitFormField {
  Name = 'name',
  Phone = 'phone',
  Email = 'email',
  Unit = 'unit',
  InviteIsSent = 'invite_is_sent',
}

export type LeadReserveUnitFormGroupType = {
  [key in ELeadReserveUnitFormField]: AbstractControl<any>;
};

export class LeadLiteModel {
  @Expose({ name: ELeadField.Id })
  id!: number;
  @Expose({ name: ELeadField.Name })
  name!: string;
  @Expose({ name: ELeadField.Email })
  email!: string;
  @Expose({ name: ELeadField.Units })
  units!: { id: number; identifier: string }[];

  @Exclude()
  selected?: boolean;
}
